export default "__VITE_ASSET__WNuG0JW0__"